(() => {
  document.querySelectorAll('[data-provas-carousel]').forEach((root) => {
    const viewport = root.querySelector('.provas__viewport');
    const track = root.querySelector('[data-provas-track]');
    const cards = [...root.querySelectorAll('[data-provas-card]')];
    const prevBtn = root.querySelector('[data-provas-nav="prev"]');
    const nextBtn = root.querySelector('[data-provas-nav="next"]');
    const dotsWrap = root.querySelector('[data-provas-dots]');
    if (!viewport || !track || !cards.length) return;

    const TAP_SLOP = 14;
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    let page = 0;
    let dragging = false;
    let didDrag = false;
    let pointerId = null;
    let startX = 0;
    let startY = 0;
    let startShift = 0;
    let lastX = 0;
    let lastT = 0;
    let velocity = 0;
    let axis = null;
    let activeCard = null;

    const perPage = () => {
      if (window.matchMedia('(max-width: 600px)').matches) return 1;
      if (window.matchMedia('(max-width: 900px)').matches) return 2;
      return 4;
    };

    const pageCount = () => Math.max(1, Math.ceil(cards.length / perPage()));

    const gap = () => {
      const styles = getComputedStyle(track);
      return parseFloat(styles.columnGap || styles.gap) || 16;
    };

    const step = () => cards[0].getBoundingClientRect().width + gap();

    const shiftForPage = (p) => p * perPage() * step();

    const maxShift = () => shiftForPage(pageCount() - 1);

    const setShift = (px, animate) => {
      track.style.transition = animate ? '' : 'none';
      track.style.transform = `translate3d(${-px}px, 0, 0)`;
    };

    const ensureSrc = (video) => {
      if (video.dataset.src && !video.getAttribute('src') && !video.querySelector('source')) {
        video.src = video.dataset.src;
      }
    };

    const pauseVideo = (media, video) => {
      if (!media || !video) return;
      video.pause();
      media.classList.remove('is-playing', 'is-loading');
      if (activeCard === media.closest('[data-provas-card]')) activeCard = null;
    };

    const playVideo = (media, video) => {
      if (!media || !video) return;
      ensureSrc(video);
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.loop = true;
      media.classList.add('is-playing', 'is-loading');

      const tryPlay = () => {
        const result = video.play();
        if (result?.then) {
          result
            .then(() => media.classList.remove('is-loading'))
            .catch(() => media.classList.remove('is-loading', 'is-playing'));
        } else {
          media.classList.remove('is-loading');
        }
      };

      if (video.readyState >= 2) {
        tryPlay();
      } else {
        video.load();
        video.addEventListener('loadeddata', tryPlay, { once: true });
        // Fallback if load stalls: still attempt play
        window.setTimeout(tryPlay, 250);
      }
    };

    const pauseAll = (exceptMedia = null) => {
      cards.forEach((card) => {
        const media = card.querySelector('[data-provas-media]');
        const video = card.querySelector('[data-provas-video]');
        if (!media || !video || media === exceptMedia) return;
        pauseVideo(media, video);
      });
    };

    const visibleCards = () => {
      const start = page * perPage();
      return cards.slice(start, start + perPage());
    };

    const playVisible = () => {
      if (canHover) return;
      const visible = visibleCards();
      const first = visible.find((card) => card.querySelector('[data-provas-video]'));
      if (!first) return;

      const media = first.querySelector('[data-provas-media]');
      const video = first.querySelector('[data-provas-video]');
      pauseAll(media);
      playVideo(media, video);
      activeCard = first;
    };

    const toggleCard = (card) => {
      const media = card.querySelector('[data-provas-media]');
      const video = card.querySelector('[data-provas-video]');
      if (!media || !video) return;

      if (media.classList.contains('is-playing') && !video.paused) {
        pauseVideo(media, video);
        return;
      }

      pauseAll(media);
      playVideo(media, video);
      activeCard = card;
    };

    const cardFromPoint = (x, y) => {
      const el = document.elementFromPoint(x, y);
      return el?.closest?.('[data-provas-card]') || null;
    };

    const renderDots = () => {
      if (!dotsWrap) return;
      const total = pageCount();
      dotsWrap.innerHTML = '';
      for (let i = 0; i < total; i += 1) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = `provas__dot${i === page ? ' is-active' : ''}`;
        btn.setAttribute('aria-label', `Ir para página ${i + 1}`);
        btn.addEventListener('click', () => {
          page = i;
          update();
        });
        dotsWrap.appendChild(btn);
      }
    };

    const update = () => {
      const total = pageCount();
      page = ((page % total) + total) % total;
      setShift(shiftForPage(page), true);
      renderDots();
      if (!canHover) {
        window.requestAnimationFrame(playVisible);
      }
    };

    const playNavReveal = (btn) => {
      btn.classList.remove('is-revealing', 'is-painted');
      void btn.offsetWidth;
      btn.classList.add('is-revealing');
      window.clearTimeout(btn._paintTimer);
      btn._paintTimer = window.setTimeout(() => {
        btn.classList.add('is-painted');
        btn.classList.remove('is-revealing');
      }, 500);
    };

    const resetNavReveal = (btn) => {
      window.clearTimeout(btn._paintTimer);
      btn.classList.remove('is-revealing', 'is-painted');
    };

    root.querySelectorAll('.provas__nav').forEach((btn) => {
      btn.addEventListener('pointerenter', () => playNavReveal(btn));
      btn.addEventListener('pointerleave', () => resetNavReveal(btn));
      btn.addEventListener('focus', () => playNavReveal(btn));
      btn.addEventListener('blur', () => resetNavReveal(btn));
    });

    prevBtn?.addEventListener('click', () => {
      page -= 1;
      update();
    });

    nextBtn?.addEventListener('click', () => {
      page += 1;
      update();
    });

    const endDrag = (event) => {
      if (pointerId === null || event.pointerId !== pointerId) return;

      const wasDragging = didDrag;
      const tapX = event.clientX;
      const tapY = event.clientY;

      dragging = false;
      didDrag = false;
      axis = null;
      root.classList.remove('is-dragging');

      try {
        viewport.releasePointerCapture(pointerId);
      } catch {
        // ignore
      }
      pointerId = null;

      const dx = event.clientX - startX;
      const threshold = Math.min(72, cards[0].getBoundingClientRect().width * 0.18);
      const flicked = Math.abs(velocity) > 0.45;

      if (wasDragging && (Math.abs(dx) > threshold || flicked)) {
        if (dx < 0 || velocity < -0.45) page += 1;
        else page -= 1;
        update();
        return;
      }

      setShift(shiftForPage(page), true);

      if (!wasDragging && !canHover) {
        const card = cardFromPoint(tapX, tapY);
        if (card?.querySelector('[data-provas-video]')) {
          toggleCard(card);
        }
      }
    };

    viewport.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      dragging = true;
      didDrag = false;
      axis = null;
      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      lastX = event.clientX;
      lastT = performance.now();
      velocity = 0;
      startShift = shiftForPage(page);

      viewport.setPointerCapture(pointerId);
    });

    viewport.addEventListener(
      'pointermove',
      (event) => {
        if (!dragging || event.pointerId !== pointerId) return;

        const dx = event.clientX - startX;
        const dy = event.clientY - startY;

        if (!axis) {
          if (Math.abs(dx) < TAP_SLOP && Math.abs(dy) < TAP_SLOP) return;
          axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (axis === 'y') {
            dragging = false;
            didDrag = false;
            root.classList.remove('is-dragging');
            try {
              viewport.releasePointerCapture(pointerId);
            } catch {
              // ignore
            }
            setShift(startShift, true);
            pointerId = null;
            return;
          }
          didDrag = true;
          root.classList.add('is-dragging');
          setShift(startShift, false);
        }

        if (axis !== 'x') return;

        event.preventDefault();
        didDrag = true;

        const now = performance.now();
        const dt = Math.max(1, now - lastT);
        velocity = (event.clientX - lastX) / dt;
        lastX = event.clientX;
        lastT = now;

        const max = maxShift();
        let next = startShift - dx;
        if (next < 0) next *= 0.35;
        if (next > max) next = max + (next - max) * 0.35;
        setShift(next, false);
      },
      { passive: false }
    );

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);

    // Block synthetic click after a real drag so it doesn't double-toggle
    viewport.addEventListener(
      'click',
      (event) => {
        if (didDrag || !canHover) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );

    cards.forEach((card) => {
      const media = card.querySelector('[data-provas-media]');
      const video = card.querySelector('[data-provas-video]');
      if (!media || !video) return;

      video.muted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.loop = true;
      video.preload = 'none';

      if (canHover) {
        media.addEventListener('pointerenter', (event) => {
          if (event.pointerType && event.pointerType !== 'mouse') return;
          pauseAll(media);
          playVideo(media, video);
          activeCard = card;
        });
        media.addEventListener('pointerleave', (event) => {
          if (event.pointerType && event.pointerType !== 'mouse') return;
          pauseVideo(media, video);
        });
      }
    });

    // Autoplay first visible card when the section enters the viewport (mobile)
    if (!canHover && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) playVisible();
            else pauseAll();
          });
        },
        { threshold: 0.35 }
      );
      io.observe(root);
    }

    let resizeTimer;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(update, 120);
    });

    update();
  });
})();
